// extracted by mini-css-extract-plugin
export default {"container":"Feedback_container__Wpwol","text":"Feedback_text__1E3+k","textarea":"Feedback_textarea__qFc9i","btn":"Feedback_btn__82bnG"};